module.exports = ".table.is-hoverable tbody tr:not(.is-selected):hover {\r\n    cursor: pointer;\r\n}\r\n"